import Content from '../../content';

namespace('IO.Views.NodeGroups', function (exports) {
  'use strict';

  var Configure = Content.extend({
    dom: {
      GROUP_PROPERTIES: '#node-group-properties',
    },

    jstTemplate: 'node_groups/property',

    events: function () {
      return {};
    },

    render: function () {
      var nodeGroupProperties = this.$(this.dom.GROUP_PROPERTIES),
        self = this;

      if (
        !nodeGroupProperties.closest('.hide').length &&
        nodeGroupProperties.length > 0
      ) {
        nodeGroupProperties.select2({
          templateResult: function (data) {
            if (!data.id) {
              return data.text;
            }
            data = nodeGroupPropertiesOptions[data.id];
            return $(self.renderTemplate(data));
          },
          multiple: true,
        });
      }
    },
  });

  exports.Configure = Configure;
});
